import { render, staticRenderFns } from "./SocialCampaignCustomFields.vue?vue&type=template&id=669de174&scoped=true&"
import script from "./SocialCampaignCustomFields.vue?vue&type=script&lang=js&"
export * from "./SocialCampaignCustomFields.vue?vue&type=script&lang=js&"
import style0 from "./SocialCampaignCustomFields.vue?vue&type=style&index=0&id=669de174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669de174",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('669de174')) {
      api.createRecord('669de174', component.options)
    } else {
      api.reload('669de174', component.options)
    }
    module.hot.accept("./SocialCampaignCustomFields.vue?vue&type=template&id=669de174&scoped=true&", function () {
      api.rerender('669de174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/SocialCampaignCustomFields.vue"
export default component.exports